import { useContext, useEffect } from "react";
import { ProcessContext } from "../../contexts/ProcessContext";

export const useActionCallback = (actionType, callback) => {
  const {
    state: {
      lastActionsReference: references,
      lastActionsReferenceLastChange: lastActions,
    },
  } = useContext(ProcessContext);

  useEffect(() => {
    if (!references) return;
    const actions = references.filter((ref) => ref.type === actionType);
    if (actions.length > 0) {
      callback(actions);
    }
  }, [lastActions]);
};
